import React, {Component} from 'react';
import {connect} from 'react-redux';
import CategoryList from "../../components/Categories/CategoryList";
import {
    changeCategorySettings, countCategories, showingEditCategoryForm,
    toGetCategories
} from "../../actions/categories";
import _ from 'lodash';
import {push} from 'react-router-redux';
import {_getSkipFilter, getTablePage} from "../../helpers/functions";
import {parseCategories, parseLogin} from "../../helpers/parseImmutables";

class CategoryListHOC extends Component {

    componentDidMount(){
        this.props.countCategories({
            accessToken: this.props.login.userInfo.token,
            brandId: this.props.login.userInfo.brand.id
        });
        this.props.getAllCategories(this.props.login.userInfo.brand.id, this.props.login.userInfo.token,
            {skip: 0, limit: 5000});
    }

    componentWillReceiveProps(nextProps){
        if(this.props.categories.page !== nextProps.categories.page ||
            this.props.categories.rowsPerPage !== nextProps.categories.rowsPerPage){
            this.props.getAllCategories(this.props.login.userInfo.brand.id, this.props.login.userInfo.token,
                {skip: _getSkipFilter(nextProps.categories.page, nextProps.categories.rowsPerPage), limit: nextProps.categories.rowsPerPage});
        }
    }

    handleRowSelect = (cid) => {
        this.props.showEditCategoryForm(this.props.categories.all[cid], cid);
        this.props.push('/category/' + cid)
    };

    handleRowsPerPage = (rowsPerPage) => {
        rowsPerPage = parseInt(rowsPerPage);
        let newTotalPages = _.ceil(this.props.categories.totalCategories / rowsPerPage);
        let currentPage = this.props.categories.page;
        if(parseInt(currentPage) > newTotalPages ){
            currentPage = newTotalPages;
        }

        this.props.changeCategorySettings('rowsPerPage', rowsPerPage);
        this.props.changeCategorySettings('page', currentPage);
    };

    handlePageChange = (iconType) => {
        let newPage  = getTablePage(iconType, this.props.categories.page,  this.props.categories.totalCategories, this.props.categories.rowsPerPage);
        this.props.changeCategorySettings('page', newPage);
    };

    render() {
        let tableColumns = [
            'category name',
        ];
        return (
            <CategoryList
                page={this.props.categories.page}
                totalRows={this.props.categories.totalCategories}
                handlePageChange={this.handlePageChange}
                rowsPerPage={this.props.categories.rowsPerPage}
                handleRowsPerPage={this.handleRowsPerPage}
                push={this.props.push}
                isFetching={this.props.categories.isFetching}
                handleRowSelect={this.handleRowSelect}
                tableColumns={tableColumns}
                categories={this.props.categories.resultsToDisplay}
                userRole={this.props.login.userInfo.role}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        login: parseLogin(state.login),
        categories: parseCategories(state.categories)
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllCategories: (brandId, token, filter) => {
            dispatch(toGetCategories(brandId, token, filter))
        },
        showEditCategoryForm: (cat, id) => {
            dispatch(showingEditCategoryForm(cat, id))
        },
        push: (url) => {
            dispatch(push(url))
        },
        changeCategorySettings: (key, value) => {
            dispatch(changeCategorySettings(key, value))
        },
        countCategories: (payload) => {
            dispatch(countCategories(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryListHOC);




// WEBPACK FOOTER //
// ./src/containers/Categories/categoryListHOC.js